import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AnalyticsService } from 'app/core/services/analytics.service';
import { DescriptionParserService } from 'app/core/services/parse-description.service';
import { Restaurant } from 'app/menu/models/restaurants.model';
import { MenuStorageService } from 'app/menu/services/menu-storage.service';
import { Item, Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';
import { PreloadImgComponent } from './../../../core/directives/preload-img/preload-img.component';
import { ItemDetailComponent } from './../item-detail/item-detail.component';

/**
 * Listado de items con foto o sin foto para menu en inifiti scroll
 */
@Component({
    selector: 'app-item-image',
    templateUrl: './item-image.component.html',
    styleUrls: ['./item-image.component.scss'],
    standalone: false
})
export class ItemImageComponent extends PreloadImgComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Listado de productos
   */
  @Input() section: SectionMenu = {} as SectionMenu;
  /**
   * Informacion del restaurante
   */
  restaurant: Restaurant = {} as Restaurant;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  /**
   * Indica el alto de la tarjeta de cada item
   * dependiendo de la plataforma (IOS o Android)
   */
  minHeigtItem = '30vh';
  maxHeigtItem = '39vh';
  /**
   * Constructor de item image
   *
   * @param menuService servicios de menu
   * @param dialog dialogo
   */
  constructor(
    private menuService: MenuService,
    public dialog: MatDialog,
    private menuStorage: MenuStorageService,
    private analyticsService: AnalyticsService,
    public descriptionParser: DescriptionParserService
  ) {
    super();
    setTimeout(() => {
      if (this.isIOSDevice() === 'IOS') {
        this.minHeigtItem = '30vh';
        this.maxHeigtItem = '38vh';
      }
    }, 1300);
  }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
    this.menuStorage.restaurant$.subscribe((rest: Restaurant) => {
      this.restaurant = rest;
    });

    this.menuService.getIsMobile().subscribe((value: boolean) => {
      if (!value) {
        this.minHeigtItem = '10vh';
      }
    });
  }

  /**
   * Abre el modal para visualizar la info del item
   *
   * @param item item a visualizar
   */
  open(item: Item): void {
    if (this.restaurant.metrics) {
      this.sendAnalyticsInfo(item);
    }
    this.dialog.open(ItemDetailComponent, {
      data: {
        item,
        menu: { ...this.menu }, // Pasar una copia superficial del menu
        color: this.getColor2()
      }
    });
  }

  /**
   * Indica si el producto tiene imagen o no
   *
   * @param item producto a evaluar
   * @returns boolean
   */
  hasImage(item: Item): boolean {
    if (item.photo && item.photo !== '' && !item.hiddenPhoto) {
      if (item.photo.length > 0) {
        return true;
      }
    }

    return false;

  }

  /**
   * Valida si el menu es en el scroll vertical y tiene
   * activado ponerle background a los items
   *
   * @returns color de background
   */
  setBackground(): string {
    if (this.menu.itemsWithBackground) {
      return this.menu.color;
    } else {
      return '#fbf8f2';
    }
  }

  /**
   * Obtiene el color del texto validando que no sea blanco
   * Nunca modifica this.menu.colorText
   *
   * @returns string con el color a usar
   */
  getColor(): string {
    // Obtener el valor del color - SOLO LECTURA
    if (!this.menu || !this.menu.colorText) {
      return '#000000';
    }

    // Guardar el valor original para asegurar que no se modifique
    const originalColorValue = this.menu.colorText;

    // Validar si el color es blanco o un tono de blanco
    // y si el menú no tiene fondo personalizado para los items
    const isWhiteColor = originalColorValue === '#ffffff' ||
      this.menuService.isWhite(originalColorValue);
    const hasItemsBackground = this.menu.itemsWithBackground;

    if (isWhiteColor && !hasItemsBackground) {
      // Devolver negro
      return '#000000';
    }
    // Devolver el valor original intacto (nunca modificado)
    return originalColorValue;
  }

    getColor2(): string {
    // Obtener el valor del color - SOLO LECTURA
    if (!this.menu || !this.menu.colorText) {
      return '#000000';
    }

    // Guardar el valor original para asegurar que no se modifique
    const originalColorValue = this.menu.colorText;

    // Validar si el color es blanco o un tono de blanco
    // y si el menú no tiene fondo personalizado para los items
    const isWhiteColor = originalColorValue === '#ffffff' ||
      this.menuService.isWhite(originalColorValue);
    const hasItemsBackground = this.menu.itemsWithBackground;

    if (isWhiteColor && !hasItemsBackground) {
      // Devolver negro
      return '#000000';
    }

    if (hasItemsBackground) {
      return this.menu.color;
    }
    // Devolver el valor original intacto (nunca modificado)
    return originalColorValue;
  }

  private isIOSDevice() {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      return 'ANDROID';
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      return 'IOS';
    }
    return 'OTHER';
  }

  /**
   * Envia la info necesaria al analytics
   *
   * @param item info del producto seleccionado
   */
  private sendAnalyticsInfo(item: Item) {
    const info = {
      restaurant_id: this.restaurant.id,
      menu_type: this.menu.departament,
      type: 'product_click',
      product_id: item.name
    };
    this.analyticsService.sendAnalyticsInfo('product_click', info);
  }
}
